import React, { useState } from 'react';
import { useNeuOeffnen } from '../components/kanzlei/NeuMenu';
import { Link, Navigate } from 'react-router-dom';
import { ArrowLeft, ListChecks, Loader2, Plus, Search } from 'lucide-react';
import Header from '../components/Header';
import { useAuth } from '../context/AuthContext';
import { TicketForm, TicketItem, useMitglieder, useTickets } from '../components/tickets/Tickets';

const TEAM = ['admin', 'kanzlei_mitarbeiter', 'kanzlei_partner', 'kanzlei_anwalt', 'kanzlei_sekretariat'];
const STATUS_F = [['aktiv', 'Offen & in Arbeit'], ['erledigt', 'Erledigt'], ['', 'Alle']];
const WER_F = [['alle', 'Alle'], ['meine', 'Meine'], ['pool', 'Team-Pool']];

const Pills = ({ opts, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-1.5">{opts.map(([k, l]) => (
    <button key={k || 'alle'} type="button" onClick={() => onChange(k)} data-testid={`${prefix}-${k || 'alle'}`}
      className={`text-xs tracking-wider px-3 py-1.5 rounded-full border transition-colors ${value === k ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'bg-white text-[#1B3A5C] border-gray-200 hover:border-[#b8893d]'}`}>{l}</button>))}</div>
);

export default function TeamTickets() {
  const { user } = useAuth();
  const mitglieder = useMitglieder();
  const [status, setStatus] = useState('aktiv');
  const [wer, setWer] = useState('alle');
  const [q, setQ] = useState('');
  const [neu, setNeu] = useState(false);
  useNeuOeffnen(setNeu, 'ticket-form');
  const { items, setItems, changed } = useTickets({ status });
  if (user && !TEAM.includes(user.role)) return <Navigate to="/dashboard" replace />;
  const s = q.trim().toLowerCase();
  const list = (items || [])
    .filter((t) => wer === 'alle' || (wer === 'meine' ? t.zustaendig?.user_id === user?.user_id : !t.zustaendig))
    .filter((t) => !s || [t.titel, t.beschreibung, t.mandant_name, t.mandanten_nr, t.akte, t.zustaendig?.name].some((v) => (v || '').toLowerCase().includes(s)));
  return (
    <div className="min-h-screen bg-[#f5f8fa]" data-testid="team-tickets-page">
      <Header />
      <main className="pt-[120px] lg:pt-[170px] pb-16 px-4 max-w-5xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-3 mt-3 mb-5">
          <div>
            <h1 className="font-serif text-3xl text-[#1B3A5C]" data-testid="tickets-titel">Aufgaben</h1>
            <p className="text-sm text-[#34536b] mt-1">Alle offenen Aufgaben, Anforderungen, Fristhinweise und Wiedervorlagen über alle Mandanten.</p>
          </div>
          <button type="button" onClick={() => setNeu((v) => !v)} className="inline-flex items-center gap-2 bg-[#1B3A5C] hover:bg-[#2A5280] text-white text-[14px] font-semibold px-4 h-[38px] rounded-[10px]" data-testid="tickets-neu"><Plus className="w-4 h-4" /> Neue Aufgabe</button>
        </div>
        {neu && <div className="mb-5"><TicketForm mitglieder={mitglieder} onCancel={() => setNeu(false)} onCreated={(t) => { setItems((cur) => [t, ...(cur || [])]); setNeu(false); }} /></div>}
        <div className="flex flex-wrap items-center gap-3 mb-4">
          <Pills opts={STATUS_F} value={status} onChange={setStatus} prefix="tickets-status" />
          <Pills opts={WER_F} value={wer} onChange={setWer} prefix="tickets-wer" />
          <div className="relative ml-auto w-full sm:w-64"><Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-[#7a8a99]" />
            <input className="w-full pl-8 pr-3 py-2 bg-white border border-gray-200 focus:border-[#b8893d] focus:outline-none text-sm rounded-sm" placeholder="Suchen…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="tickets-suche" /></div>
        </div>
        {!items ? <div className="flex items-center gap-2 text-sm text-[#34536b]"><Loader2 className="w-4 h-4 animate-spin" /> Lade Tickets…</div>
          : list.length === 0 ? <div className="bg-white border border-gray-100 p-10 text-center text-sm text-[#7a8a99]" data-testid="tickets-leer">Keine Tickets in dieser Ansicht.</div>
          : <ul className="space-y-2" data-testid="tickets-liste">{list.map((t) => <TicketItem key={t.ticket_id} t={t} mitglieder={mitglieder} onChanged={changed} zeigeBezug />)}</ul>}
      </main>
    </div>
  );
}
